import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=54a37ef8&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.sass?vue&type=style&index=0&id=54a37ef8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a37ef8",
  null
  
)

export default component.exports